<template>
  <div v-if="hasPermission">
    <slot />
  </div>
  <div v-else-if="$slots.fallback">
    <slot name="fallback" />
  </div>
</template>

<script>
export default {
  name: 'PermissionGuard',
  props: {
    action: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasPermission() {
      return this.$can(this.action, this.subject)
    },
  },
}
</script>
